<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'PillWrapper',
  props: {
    disabled: { required: false, type: Boolean },
    selected: { required: false, type: Boolean },
  },
  setup(props) {
    const borderColorUtils = computed(() => {
      if (props.selected) return 'border-black bg-neutral-100';
      return 'border-neutral-200';
    });

    const hoverUtils = computed(() => {
      if (props.disabled) return 'text-neutral-400 cursor-not-allowed';
      return 'cursor-pointer hover:bg-neutral-100';
    });

    return {
      borderColorUtils,
      hoverUtils,
    };
  },
});
</script>

<template>
  <div
    class="flex justify-between px-6 py-3 text-sm border border-solid md:py-4 md:px-8 rounded-4xl md:text-base"
    :class="[borderColorUtils, hoverUtils]"
  >
    <slot />
  </div>
</template>
